import { render, staticRenderFns } from "./Promemoria.vue?vue&type=template&id=9ac06ca2&"
import script from "./Promemoria.vue?vue&type=script&lang=js&"
export * from "./Promemoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports